import clsx from 'clsx';
import * as React from 'react';
import { useState } from 'react';
import { getColor } from '../../data/utils';
import ArrowIcon from '../icons/ArrowIcon';
import { Part } from '../types';

interface PartListProps {
    parts: Part[];
    selected?: Part;
    onSelect?: (part: Part) => void;
}

export default function PartList({ parts, selected, onSelect }: PartListProps) {
    const [sortBy, setSortBy] = useState<keyof Part | null>('id');
    const [direction, setDirection] = useState<1 | -1>(1);

    function handleSort(nextSortBy: keyof Part) {
        if (!sortBy || sortBy !== nextSortBy) {
            setSortBy(nextSortBy);
        } else if (sortBy === nextSortBy) {
            toggleDirection();
        }
    }

    function toggleDirection() {
        // @ts-ignore
        setDirection(direction * -1);
    }

    return (
        <div className="parts__list">
            <div className="parts__controls">
                <div className="buttongroup">
                    {['id', 'name', 'type'].map((label) => (
                        <button
                            key={label}
                            className={clsx('button button--small', {
                                isSelected: label === sortBy,
                            })}
                            onClick={() => handleSort(label as keyof Part)}
                        >
                            {label}
                        </button>
                    ))}
                </div>
                <div
                    className={clsx('parts__sorting-icon', {
                        asc: direction === 1,
                    })}
                    onClick={toggleDirection}
                >
                    <ArrowIcon />
                </div>
            </div>
            <ul>
                {[...parts]
                    .sort(
                        (a, b) => (a[sortBy] > b[sortBy] ? 1 : -1) * direction
                    )
                    .map((part, index) => (
                        <li
                            key={`${part.id}`}
                            id={`part-list-item-${part.id}`}
                            className={clsx({
                                isSelectable: !!onSelect,
                                isSelected: selected && part.id === selected.id,
                            })}
                            onClick={() => onSelect(part)}
                        >
                            <span className="index">{part.id}</span>
                            <span className="label">
                                <span className="name">{part.name}</span>
                                <span className="type">{part.type}</span>
                            </span>
                            {(part.color || part.swatch) && (
                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: getColor(part),
                                    }}
                                />
                            )}
                        </li>
                    ))}
            </ul>
        </div>
    );
}
